<template>
  <v-row>
    <v-col cols="7" offset="2">
      <svg id="legend"></svg>
    </v-col>
    <v-col class="body-2 px-1 primary--text" cols="5" v-if="false">
      Colores según proporción entre mujeres y hombres
    </v-col>    
  </v-row>
</template>

<script>

import { mapState, } from "vuex";
import * as d3 from 'd3';
import * as d3Array from 'd3-array';
import homeMixin from "../homeMixin";

export default {
  name: 'Legend',
  components: {
  },
  mixins: [homeMixin],
  props:{
    ies:{
      type: Object,
      required: false,
    },
  },
  data(){
    return {
      is_tooltip:false,
      posX:-200,
      posY:-200,
      tt_data: undefined,
      sizes:{
        width: 450,
        height: 450,
        margin_top: 110,
      }
    }
  },
  computed:{
    ...mapState({
      segmentos: state => state.segmentos,
      gpos_segmento: state => state.gpos_segmento,
    }),

  },
  methods: {

    buildLegend(){

      var height = 40,
          width = 120,
          margin = 10;

      var legend = d3.select('#legend')
      legend
        //.attr('width', width + margin*3)
        //.attr('height', width + (margin*2));
        .attr("viewBox", [0, 0, 
            (height *2.7) + (margin*3), 
            width  + (margin*2)])


      var svgDefs = legend.append('defs');

      var mainGradient = svgDefs.append('linearGradient')
          .attr('id', 'mainGradient')
          .attr("gradientTransform", "rotate(90)");

      mainGradient.append('stop')
          .style('stop-color', this.color_m)
          .attr('offset', '0');

      mainGradient.append('stop')
          .style('stop-color', 'white')
          .attr('offset', '0.5');

      mainGradient.append('stop')
          .style('stop-color', this.color_h)
          .attr('offset', '1');

      legend.append('rect')
          .classed('filled', true)
          .attr('x', margin * 2)
          .attr('y', margin)
          .style('fill', 'url(#mainGradient)')
          .attr('width', height)
          .attr('height', width);

      var x = d3.scalePoint()
        .domain(["100% Mujeres", "75% Mujeres", "Equidad", "75% Hombres", "100% Hombres"])
        .range([0 + margin, width + margin])

      legend 
        .append("g")
        .attr("transform", `translate(${margin*2+height},0)`)
        .call(d3.axisRight(x))

    },    

  },
  created(){
  },
  mounted(){
    this.$nextTick( () =>{
      this.buildLegend()
      //this.gaugeChart2(2.34, data[1].items);
    })
  }
}
</script>

<style lang="scss" scoped>
</style>